export default function LoadingState() {
  return (
    <div>
      <div className="h-3 w-24 animate-pulse rounded bg-ink-100" />
      <div className="mt-2 h-9 w-80 max-w-full animate-pulse rounded bg-ink-100" />
      <div className="mt-3 h-4 w-full max-w-lg animate-pulse rounded bg-ink-100" />

      <div className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="h-28 animate-pulse rounded-2xl bg-gradient-to-br from-ink-50 to-ink-100"
          />
        ))}
      </div>

      <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="h-56 animate-pulse rounded-2xl bg-gradient-to-br from-ink-50 to-ink-100"
          />
        ))}
      </div>
    </div>
  );
}
